type dataType =
  | 'string'
  | 'number'
  | 'bigint'
  | 'boolean'
  | 'symbol'
  | 'undefined'
  | 'object'
  | 'function'

let duration = 0 // 停留时间
let lastPath: string | null = null // 上一次的路径

const getStorage = (key: string) => {
  const storage = window.localStorage
  const storageData = storage.getItem(key)
  if (!storageData) return storageData
  try {
    const resData = JSON.parse(storageData)
    const dataType: dataType = resData.type
    const { data } = resData

    // 布尔值 返回data
    if (dataType === 'boolean') return data === true
    // 对象返回
    if (dataType === 'string' && data === 'null') {
      return null
    }
    // z字符串返回
    if (dataType === 'string' && data === 'undefined') return undefined
    // number
    if (dataType === 'number') return Number(data)
    return data
  } catch (error) {
    return storageData
  }
}

export const trackPageView = (location: {
  pathname: string
  query: object
  hash: string
  search: string
  state: object
}) => {
  try {
    const { pathname, query, search } = location

    const env = process.env.UMI_ENV
    if (window.ineum) {
      window.ineum('meta', 'url', window.location.href)
      window.ineum('meta', 'ua', window.navigator.userAgent)
      window.ineum('meta', 'env', env)
      window.ineum('meta', 'token', getStorage('h5Token'))
      window.ineum('meta', 'tenantCode', getStorage('tenantCode'))
      window.ineum('meta', 'channel', getStorage('channel'))
      window.ineum('page', pathname)
      window.ineum('wrapEventHandlers', true)
      window.ineum('wrapTimers', true)
      window.ineum('allowedOrigins', [/.*\.dragonpass\..com.*/])
      window.ineum('captureHeaders', [/content-type/i, /x-capture-body/i])
      window.ineum('ignoreErrorMessages', [
        /Fw/i,
        /^Script error\.$/i,
        /stopAudio/i,
        /openBackAudio/i,
        /taskHasFinishToReloadData/i,
        /_SCREEN_SHOT_REPORT_/i,
        /RainbowBridge/i,
        /webViewWillAppear/i,
        /EMPJSBridge/i,
        /backBtnClick_iOS/i,
        /closeMonitoring/i,
      ])

      console.log(
        `%c[Instana]%c reportEvent PAGE_VIEW`,
        'color: white; background-color: #1e88e5; padding: 2px 4px; border-radius: 3px;',
        'color: #1e88e5; font-weight: bold;',
      )
      window.ineum('reportEvent', 'PAGE_VIEW', {
        timestamp: Date.now(),
        meta: {
          fromUrl: lastPath,
          routePath: (location.hash || '').replace('#', '').split('?')[0],
          search,
          tenantCode: getStorage('tenantCode'),
          locale: window?.localStorage.getItem('umi_locale'),
          token: getStorage('h5Token'),
          qrcodeToken: getStorage('qrcodeToken'),
          query: JSON.stringify(query || {}),
          stayDuration: lastPath ? Date.now() - duration : 0,
        },
      })
    } else {
      console.warn('log', {
        timestamp: Date.now(),
        meta: {
          fromUrl: lastPath,
          locale: window?.localStorage.getItem('umi_locale'),
          url: window.location.href,
          userAgent: window.navigator.userAgent,
          tenantCode: getStorage('tenantCode'),
          token: getStorage('h5Token'),
          qrcodeToken: getStorage('qrcodeToken'),
          query: JSON.stringify(query || {}),
          env,
          stayDuration: lastPath ? Date.now() - duration : 0,
        },
      })
    }
    duration = Date.now()
    lastPath = pathname
  } catch (error) {
    try {
      if (window.ineum) {
        const err = error instanceof Error ? error : new Error(String(error))
        window.ineum('reportError', err, {
          meta: {
            type: 'track_page_view_error',
            url: window.location.href,
            errorMsg: err.message,
            errorStack: err.stack,
          },
        })
      }
    } catch (err) {
      console.log('instana upload failed')
    }
  }
}

export const trackMasterFrameworkSuccess = () => {
  if (window.ineum) {
    try {
      console.log(
        `%c[Instana]%c reportEvent MASTER_FRAMEWORK_LOAD_SUCCESS`,
        'color: white; background-color: #1e88e5; padding: 2px 4px; border-radius: 3px;',
        'color: #1e88e5; font-weight: bold;',
      )
      // console.warn('log', 'reportEvent', 'MASTER_FRAMEWORK_LOAD_SUCCESS')
      window.ineum('reportEvent', 'MASTER_FRAMEWORK_LOAD_SUCCESS', {
        timestamp: Date.now(),
        meta: {
          url: window.location.href,
          fromUrl: lastPath,
          tenantCode: getStorage('tenantCode'),
        },
      })
    } catch (err) {
      console.log('instana upload failed')
    }
  }
}

export const getTrackHeaderScripts = () => {
  const env = process.env.UMI_ENV
  // return []
  if (process.env.NODE_ENV === 'production') {
    if (env === 'prod') {
      return [
        {
          content: `
           (function(s,t,a,n){s[t]||(s[t]=a,n=s[a]=function(){n.q.push(arguments)},
            n.q=[],n.v=2,n.l=1*new Date)})(window,"InstanaEumObject","ineum");
            ineum('reportingUrl', 'https://h5-quanyi.dragonpass.com.cn/__instana/');
            ineum('key', 'wu_WTFQlQYuX19qaw-t7Tw');
            ineum('trackSessions');
            ineum('autoPageDetection', false);

            console.log('%c[Instana]%c reportEvent HTML_LOAD_SUCCESS', 'color: white; background-color: #1e88e5; padding: 2px 4px; border-radius: 3px;', 'color: #1e88e5; font-weight: bold;');
            if(window.ineum) {
                ineum('reportEvent', 'HTML_LOAD_SUCCESS', {
                    timestamp: Date.now(),
                    meta: {
                        url: window.location.href,
                    },
                })
            }
        `,
        },
        {
          src: './js/instana-1.8.1.min.js',
          async: true,
          crossorigin: 'anonymous',
          // integrity:
          //   'sha384-HJjb3vveemdYNUfM1D28dTeXpPPbwPWJinH9ldaGt3KxCO0PNRc4Jb3oQIxMmJMk',
        },
      ]
    } else if (env === 'ali-uat') {
      return [
        {
          content: `
           (function(s,t,a,n){s[t]||(s[t]=a,n=s[a]=function(){n.q.push(arguments)},
            n.q=[],n.v=2,n.l=1*new Date)})(window,"InstanaEumObject","ineum");
            ineum('reportingUrl', 'https://quanyi-h5-uat.dragonpass.com.cn/__instana/');
            ineum('key', 'OWLDyOnOR5-Up5vYzfCfdQ');
            ineum('trackSessions');
            ineum('autoPageDetection', false);

            console.log('%c[Instana]%c reportEvent HTML_LOAD_SUCCESS', 'color: white; background-color: #1e88e5; padding: 2px 4px; border-radius: 3px;', 'color: #1e88e5; font-weight: bold;');
            if(window.ineum) {
                ineum('reportEvent', 'HTML_LOAD_SUCCESS', {
                    timestamp: Date.now(),
                    meta: {
                        url: window.location.href,
                    },
                })
            }
        `,
        },
        {
          // src: 'https://eum.instana.io/1.7.5/eum.min.js',
          src: './js/instana-1.8.1.min.js',
          async: true,
          crossorigin: 'anonymous',
          // integrity:
          //   'sha384-HJjb3vveemdYNUfM1D28dTeXpPPbwPWJinH9ldaGt3KxCO0PNRc4Jb3oQIxMmJMk',
        },
      ]
    } else if (env === 'test') {
      return [
        {
          content: `
           (function(s,t,a,n){s[t]||(s[t]=a,n=s[a]=function(){n.q.push(arguments)},
            n.q=[],n.v=2,n.l=1*new Date)})(window,"InstanaEumObject","ineum");
            ineum('reportingUrl', 'https://quanyi-h5-test.dragonpass.com.cn/__instana/');
            ineum('key', '4P48CbkBQ2WlrSr1DThjzg');
            ineum('trackSessions');
            ineum('autoPageDetection', true);

            console.log('%c[Instana]%c reportEvent HTML_LOAD_SUCCESS', 'color: white; background-color: #1e88e5; padding: 2px 4px; border-radius: 3px;', 'color: #1e88e5; font-weight: bold;');
            if(window.ineum) {
                ineum('reportEvent', 'HTML_LOAD_SUCCESS', {
                    timestamp: Date.now(),
                    meta: {
                        url: window.location.href,
                    },
                })
            }
        `,
        },
        {
          // src: 'https://eum.instana.io/1.7.5/eum.min.js',
          src: './js/instana-1.8.1.min.js',
          async: true,
          crossorigin: 'anonymous',
          // integrity:
          //   'sha384-HJjb3vveemdYNUfM1D28dTeXpPPbwPWJinH9ldaGt3KxCO0PNRc4Jb3oQIxMmJMk',
        },
      ]
    }
  }

  return [
    {
      content: `
         (function(s,t,a,n){s[t]||(s[t]=a,n=s[a]=function(){n.q.push(arguments)},
          n.q=[],n.v=2,n.l=1*new Date)})(window,"InstanaEumObject","ineum");
          ineum('reportingUrl', 'https://quanyi-h5-test.dragonpass.com.cn/__instana/');
          ineum('key', '4P48CbkBQ2WlrSr1DThjzg');
          ineum('trackSessions');
          ineum('autoPageDetection', true);

          console.log('%c[Instana]%c reportEvent HTML_LOAD_SUCCESS', 'color: white; background-color: #1e88e5; padding: 2px 4px; border-radius: 3px;', 'color: #1e88e5; font-weight: bold;');
          if(window.ineum) {
                ineum('reportEvent', 'HTML_LOAD_SUCCESS', {
                    timestamp: Date.now(),
                    meta: {
                        url: window.location.href,
                    },
                })
            }
      `,
    },
    {
      // src: 'https://eum.instana.io/1.7.5/eum.min.js',
      src: './js/instana-1.8.1.min.js',
      async: true,
      crossorigin: 'anonymous',
      // integrity:
      //   'sha384-HJjb3vveemdYNUfM1D28dTeXpPPbwPWJinH9ldaGt3KxCO0PNRc4Jb3oQIxMmJMk',
    },
  ]

  return []
}
